import { createContext, useState } from "react";

export const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const [popups, setPopups] = useState([]);

  const openPopup = (content) => {
    setPopups((prev) => [...prev, content]);
  };

  const closePopup = () => {
    setPopups((prev) => prev.slice(0, -1));
  };

  return (
    <PopupContext.Provider value={{ openPopup, closePopup }}>
      {children}
      {popups.map((PopupContent, index) => (
        <div
          key={index}
          className="fixed inset-0 z-[1000] bg-black bg-opacity-50 flex items-center justify-center"
        >
          <div
            className="relative z-[1001] md:min-w-[500px]"
            style={{ boxShadow: "30px 30px 30px 0px rgba(0, 0, 0, 0.1)" }}
            onClick={(e) => e.stopPropagation()}
          >
            {PopupContent}
          </div>
        </div>
      ))}
    </PopupContext.Provider>
  );
};
